import { makeStyles } from '@material-ui/core/styles';
import { COLORS } from '../../styles/constants';

export const useAccordionStyles = makeStyles({
	root: {
		'&:not(:first-child)': {
			borderTop: `1px solid ${COLORS.BORDER_TABLE_ROW}`
		},
		'&$expanded': {
			margin: 0
		},
		'&:before': {
			display: 'none'
		}
	},
	expanded: {},
	rounded: {
		'&:first-child': {
			borderTopRightRadius: 0,
			borderTopLeftRadius: 0
		}
	}
});

export const useAccordionSummaryStyles = makeStyles({
	root: {
		'&$expanded': {
			minHeight: 48
		}
	},
	content: {
		margin: 0,
		'&$expanded': {
			margin: 0
		}
	},
	expanded: {}
});

export const useAccordionDetailsStyles = makeStyles(theme => ({
	root: {
		display: 'block',
		padding: `${theme.spacing(1)}px ${theme.spacing(2)}px`,
		paddingTop: 0
	}
}));
